import { KEY_SESSION_STORAGE } from '~/constants';
import { getFromSessionStorage, saveToSessionStorage } from '~/helpers/storage';
import EE from '~/listenerEventService/EventEmitter';
import { clickstreamLogger } from '~/logging';

const originalPushState = history.pushState;
const originalReplaceState = history.replaceState;

export default class LocationListener extends EE implements IListener {
  oldURL = '';

  onHashChange = (event: HashChangeEvent) => {
    const oldURL = event.oldURL ? event.oldURL : this.oldURL;
    const newURL = event.newURL ? event.newURL : location.href;
    this.oldURL = newURL;
    clickstreamLogger.debug(`Hash change ${oldURL} -> ${newURL}`);

    this.emit('analytics', {
      type: 'hash-change',
      newURL,
      oldURL,
    });
  }

  onHistoryChange = () => {
    const oldURL = this.oldURL;
    const newURL = location.href;
    this.oldURL = newURL;

    if (
      newURL.replace(location.hash, '') !==
      oldURL.substr(0, oldURL.indexOf('#'))
    ) {
      clickstreamLogger.debug(`Pop state ${oldURL} -> ${newURL}`);
      this.emit('analytics', {
        type: 'pop-state',
        newURL,
        oldURL,
      });

      this.emit('analytics', {
        type: 'start-page-url',
        target: document,
        url: this.oldURL,
        changed: true,
        referer: document.referrer,
      });
    }
  }

  start() {
    this.oldURL = location.href;

    const currentUrl = getFromSessionStorage(KEY_SESSION_STORAGE, 'currentUrl');
    const urlChanged = currentUrl !== location.href;

    if (urlChanged) {
      saveToSessionStorage(KEY_SESSION_STORAGE, 'previousUrl', currentUrl);
      saveToSessionStorage(KEY_SESSION_STORAGE, 'currentUrl', location.href);
    }

    clickstreamLogger.debug(
      `Start page url ${
        this.oldURL
      }, urlChanged: ${urlChanged}, previousUrl: ${getFromSessionStorage(
        KEY_SESSION_STORAGE,
        'previousUrl'
      )}, currentUrl: ${getFromSessionStorage(
        KEY_SESSION_STORAGE,
        'currentUrl'
      )}`
    );

    this.emit('analytics', {
      type: 'start-page-url',
      target: document,
      url: this.oldURL,
      changed: urlChanged,
      referer: document.referrer,
    });

    window.addEventListener('hashchange', this.onHashChange);
    window.addEventListener('popstate', this.onHistoryChange);

    history.pushState = (...args) => {
      originalPushState.apply(history, args);
      this.onHistoryChange();
    };

    history.replaceState = (...args) => {
      originalReplaceState.apply(history, args);
      this.onHistoryChange();
    };
  }

  stop() {
    window.removeEventListener('hashchange', this.onHashChange);
    window.removeEventListener('popstate', this.onHistoryChange);

    history.pushState = originalPushState;
    history.replaceState = originalReplaceState;

    this.oldURL = '';
  }
}
